import _clonedeep from 'lodash.clonedeep'
import { createReducer, updateState } from "redux/handlers"
import types from './types'

const outboundInitialData = {
  channel: '',
  provider: '',
  brand: [],
  delegation: [],
  deliveryChannel: {
    channel: null,
    assignToMe: false,
    isBlockedAssignToMe: false
  },
  deliveryChannelOptions: null,
  to: {
    chips: [],
    input: ''
  },
  cc: {
    chips: [],
    input: ''
  },
  cco: {
    chips: [],
    input: ''
  },
  template: null,
  subject: '',
  message: {},
  visibleFields: ['to'],
  variables: [],
  templateVariables: []
}

const initialState = {
  modals: []
}

const openOutbound = (state, action) => updateState(state, {
  modals: [
    ...state.modals,
    {
      isOpen: true,
      isMinimize: false,
      isMaximize: false,
      currentData: {
        ..._clonedeep(outboundInitialData),
        channel: action.payload.channel || 'whatsapp'
      }
    }
  ]
})

const closeOutbound = (state, action) => {
  const newModals = [...state.modals]
  newModals.splice(action.payload.outboundIndex, 1)

  return updateState(state, {
    modals: newModals
  })
}

const toggleMinimizeOutbound = (state, action) => updateState(state, {
  modals: Object.assign([...state.modals], {
    [action.payload.outboundIndex]: {
      ...state.modals[action.payload.outboundIndex],
      isMinimize: !state.modals[action.payload.outboundIndex].isMinimize,
      isMaximize: false
    }
  })
})

const toggleMaximizeOutbound = (state, action) => {
  let newModals = []

  if (!state.modals[action.payload.outboundIndex].isMaximize) {
    state.modals.forEach(modal => {
      newModals.push({
        ...modal,
        isMinimize: true,
        isMaximize: false
      })
    })
  } else {
    newModals = [...state.modals]
  }

  return updateState(state, {
    modals: Object.assign([...newModals], {
      [action.payload.outboundIndex]: {
        ...newModals[action.payload.outboundIndex],
        isMaximize: !newModals[action.payload.outboundIndex].isMaximize,
        isMinimize: false
      }
    })
  })
}

const setCurrentDataOutbound = (state, action) => updateState(state, {
  modals: Object.assign([...state.modals], {
    [action.payload.outboundIndex || state.modals.length]: {
      ...state.modals[action.payload.outboundIndex],
      isOpen: true,
      draftId: action.payload.draftId || '',
      currentData: { ..._clonedeep(outboundInitialData), ...action.payload.outboundCurrentData }
    }
  })
})

export default createReducer(initialState, {
  [types.OPEN_OUTBOUND]: openOutbound,
  [types.CLOSE_OUTBOUND]: closeOutbound,
  [types.TOGGLE_MINIMIZE_OUTBOUND]: toggleMinimizeOutbound,
  [types.TOGGLE_MAXIMIZE_OUTBOUND]: toggleMaximizeOutbound,
  [types.SET_CURRENT_DATA_OUTBOUND]: setCurrentDataOutbound
})
